import { render } from "./AuditLog.vue?vue&type=template&id=28b1abd0&scoped=true&ts=true"
import script from "./AuditLog.vue?vue&type=script&lang=ts"
export * from "./AuditLog.vue?vue&type=script&lang=ts"

import "./AuditLog.vue?vue&type=style&index=0&id=28b1abd0&lang=scss&scoped=true"
import "./AuditLog.vue?vue&type=style&index=1&id=28b1abd0&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b1abd0"]])

export default __exports__